// @flow
import $ from 'jquery';
// import JQueryView, { on } from 'application/views/common/JQueryView';
import JQueryView, { on } from '../../../../../common/JQueryView';
import dayjs from 'dayjs';
import DateRangePicker from '../../../../../common/DateRangePicker';

export default class NewView extends JQueryView {
  from_rightholder_first_tran_on: string;

  constructor(from_rightholder_first_tran_on: string) {
    super('.change-owners-wrapper');
    this.from_rightholder_first_tran_on = from_rightholder_first_tran_on;
    this.initDateRangePicker(this.$el);
  }
  @on({ event: 'click', selector: '.registration-register-card' })
  onChangeRegisterCard(el: any) {
    const target = $(el.currentTarget);
    if (target.hasClass('is_active')) return;

    // 青枠の付与
    $('.registration-register-card').toggleClass('is_active');

    const inherit = '10';
    const transfer = '9';

    const operationType = $(
      '#company_stock_option_change_owner_form_from_right_attributes_operation_type',
    );

    // 名義書換え理由をセット
    if (operationType.val() === inherit) {
      operationType.val(transfer);
    } else {
      operationType.val(inherit);
    }
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.from_rightholder_first_tran_on,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  render() {
    this.initDateRangePicker(this.$el);
  }

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    $(event.target)
      .parents('.input-group')
      .children('input,.daterange-picker')
      .focus();
  }
}
